var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartPieSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.962 15H17V1.036C17 .472 17.381 0 18 0c7.731 0 14 6.269 14 14 0 .563-.475 1-1.038 1zM11.887 2.324C13.02 2.085 14 3.013 14 4.169V18h13.831c1.157 0 2.082.981 1.844 2.113C28.244 26.905 22.219 32 15 32 6.719 32 0 25.288 0 17 0 9.781 5.096 3.758 11.887 2.324z",
    fill: "#fff"
  })));
}

export default SvgChartPieSimple;